import { Grid } from "@material-ui/core";
import { Modal } from "App/Component/ui";
import ListFixedAsset from "../../../HelpDesk/ui/FormDetail/ListFixedAsset";
export default function ModalFixedAsset({
  setShowModal,
  handleClickSelectAsset,
  formData,
}) {
  // const succesCreateOrUpdate = async (label) => {
  //   defaultToastSuccess(`Berhasil ${label} Barang`);
  //   const res = await getReqListById(formData.idReq);
  //   setListREQ(res.data);

  // };
  return (
    <Modal title={`Pilih Fixed Asset`} show={setShowModal} width="80%">
      <Grid container spacing={1}>
        <Grid item lg={12}>
          <ListFixedAsset
            clickSelectHandler={handleClickSelectAsset}
            formData={formData}
          />
        </Grid>
      </Grid>
    </Modal>
  );
}
